import React from 'react';
import Singletons from 'controllers/Singletons';
import api from 'controllers/raymanAPI';
import {FilesCtx, FilesCtxProvider} from './files';

function mapChannel(item)
{
    // let currentUserRole = "admin";
    // if(item.users.includes(Singletons.currentUser.userID)) currentUserRole = "user";
    // if(item.profiles.operators === Singletons.currentUser.userID) currentUserRole = "operator";
    
    // return {...item, id: item.channelID, notifications: currentUserRole !== "admin" ? item.unreadMessages : 0, operator: item.profiles.operators, expert: item.profiles.experts, closed: item.disabled, currentUserRole: currentUserRole}

    return {
        ...item, 
        id: item.channelID, 
        notifications: item.unreadMessages, 
        closed: item.disabled, 
        isManager: Singletons.currentUser.profiles.includes("administrators") || item.managers.includes(Singletons.currentUser.userID)
    }
}

async function getData()
{
    let indexed = {};

    let response = await api.channels.getAll();
    let data = await response.json();

    data = data.map((item)=>mapChannel(item));
    data.forEach(item => indexed[item.channelID] = item);
    
    return {array: data, indexed: indexed};
}

const ChannelsCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {}
    }, 
    funcs: {
        clearNotifications: (channelID) => {},
        create: ()=>{},
        disable: (channelID)=>{},
        enable: (channelID)=>{},
        update: (channelID, data)=>{}
    }
});

function ChannelsCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: []});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalAdd = React.useCallback(async (channelID, opData) => {
        // ignore duplicated messages
        if(data.indexed[channelID] !== undefined) return;
        
        let tmp = {...data};
        if(!opData)
        {
            let result = await api.channels.getSingle(channelID);
            if(result.ok) opData = await result.json();
        }
        if(opData)
        {
            let item = mapChannel(opData);
            let index = tmp.array.push(item);
            tmp.indexed[item.id] = tmp.array[index-1];
            
            setData(tmp);
        }
    }, [data]);

    const internalUpdate = React.useCallback((channelID, opData) => {
        let tmp = {...data};
        Object.keys(opData).forEach((key) => {
            tmp.indexed[channelID][key] = opData[key];
        })
        // tmp.indexed[channelID] = {...tmp.indexed[channelID], ...opData};
        setData(tmp);
    }, [data]);

    const internalUpdateFromAPI = React.useCallback(async (channelID) => {
        let result = await api.channels.getSingle(channelID);
        if(result.ok)
        {
            let item = mapChannel(await result.json());
            internalUpdate(item.id, item);            
        }
    }, [internalUpdate]);

    // const internalDelete = React.useCallback((channelID, data) => {

    // }, [data]);


    //#region Notification Handlers

    React.useEffect( function handleChatNotifications() {
        function notificationHandler(notification, target) {
            if(target !== 'user') return;

            let tmp = {...data};
            let channelID = notification.channelID;
            if(tmp.indexed[channelID])
            {
                tmp.indexed[channelID].notifications += 1;
                tmp.indexed[channelID].lastMessage = notification.datetime;
                setData(tmp);
            }
        }

        Singletons.NotificationsSocket.on('channels.chat.messages.created', notificationHandler);
        return () => {Singletons.NotificationsSocket.off('channels.chat.messages.created', notificationHandler);}
    }, [data]);

    React.useEffect( function handleChannelsListChangedNotification() {

        const create = (message) => internalAdd(message.channelID, message);
        const enable = (message) => internalUpdate(message.channelID, {closed: false, closeDatetime: null});
        const disable = (message) => internalUpdate(message.channelID, {closed: true, closeDatetime: message.datetime});
        const update = (message) => internalUpdate(message.channelID, message);

        Singletons.NotificationsSocket.on('channels.created', create);
        Singletons.NotificationsSocket.on('channels.disabled', disable);
        Singletons.NotificationsSocket.on('channels.enabled', enable);
        Singletons.NotificationsSocket.on('channels.updated', update);

        return () => {
            Singletons.NotificationsSocket.off('channels.created', create);
            Singletons.NotificationsSocket.off('channels.disabled', disable);
            Singletons.NotificationsSocket.off('channels.enabled', enable);
            Singletons.NotificationsSocket.off('channels.updated', update);
        }

    }, [internalAdd, internalUpdate]);

    //#endregion


    const clearNotifications = React.useCallback((channelID) => {
        let tmp = {...data};
        
        if(tmp.indexed[channelID] && tmp.indexed[channelID].notifications && tmp.indexed[channelID].notifications > 0)
        {
            tmp.indexed[channelID].notifications = 0;
            setData(tmp);
        }
    }, [data]);


    const create = React.useCallback(async (data) => {
        let result = await api.channels.post(data);
        if(result.ok)
        {
            //internalAdd(await result.json().channelID);
            // Se recibe como notificación, no hace falta añadirlo a mano
        }
    }, []);

    const update = React.useCallback(async (channelID, data) => {
        let result = await api.channels.updateSingle(channelID, data);
        if(result.ok) internalUpdate(channelID, data);
    }, [internalUpdate]);

    const disable = React.useCallback(async (channelID) => {
        let result = await api.channels.disableSingle(channelID);
        if(result.ok) internalUpdateFromAPI(channelID);
    }, [internalUpdateFromAPI]);

    const enable = React.useCallback(async (channelID) => {
        let result = await api.channels.enableSingle(channelID);
        if(result.ok) internalUpdateFromAPI(channelID);
    }, [internalUpdateFromAPI]);

    return <ChannelsCtx.Provider value={{loading: loading, data: {...data}, funcs: {clearNotifications: clearNotifications, create: create, update: update, disable: disable, enable: enable}}} >
        {props.children}
        </ChannelsCtx.Provider>
}

function ChannelFilesProvider({channelID, ...props})
{
    return <FilesCtxProvider apiEndpoint={api.channels.files} apiParams={[channelID]}>
        <ChannelFilesNotificationHandler channelID={channelID}>
            {props.children}
        </ChannelFilesNotificationHandler>
        </FilesCtxProvider>
}

function ChannelFilesNotificationHandler({channelID, ...props})
{
    const filesCtx = React.useContext(FilesCtx);

    React.useEffect( function handleChatNotifications() {

        const addFile = (message) => {if(message.channelID === channelID) filesCtx.funcs.internal.add(message.fileInfo.fileID, message.fileInfo);}
        const deleteFile = (message) => {if(message.channelID === channelID) filesCtx.funcs.internal.delete(message.fileID);}
        const refreshFile = (message) => {if(message.channelID === channelID) filesCtx.funcs.internal.refresh(message.fileInfo.fileID);}

        Singletons.NotificationsSocket.on('channels.files.created', addFile);
        Singletons.NotificationsSocket.on('channels.files.deleted', deleteFile);
        Singletons.NotificationsSocket.on('channels.files.updated', refreshFile);

        return () => {
            Singletons.NotificationsSocket.off('channels.files.created', addFile);
            Singletons.NotificationsSocket.off('channels.files.deleted', deleteFile);
            Singletons.NotificationsSocket.off('channels.files.updated', refreshFile);
        }
    }, [filesCtx, channelID]);

    return <>{props.children}</>;

}

export {ChannelsCtx, ChannelsCtxProvider, ChannelFilesProvider};
export {FilesCtx as ChannelFilesCtx} from './files';